import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Leaf, ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("La password deve avere almeno 6 caratteri"); return; }
    if (password !== confirm) { setError("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata. Accedi con la nuova password.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9] px-6">
        <div className="text-center">
          <p className="font-serif text-2xl text-stone-800 mb-4">Link non valido</p>
          <button data-testid="reset-no-token-login" onClick={() => navigate("/login")} className="text-brand font-semibold hover:underline">Torna al login</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9] px-6 noise-overlay">
      <div className="w-full max-w-sm animate-fade-in-up">
        <div className="flex items-center gap-2 mb-10">
          <div className="w-9 h-9 rounded-sm bg-brand flex items-center justify-center"><Leaf className="text-white" size={18} strokeWidth={1.5} /></div>
          <span className="font-serif text-2xl text-stone-900 tracking-tight">Q<span className="text-brand">COST</span></span>
        </div>
        <ShieldCheck size={36} className="text-brand mb-4" />
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-stone-900 mb-2">Nuova password</h1>
        <p className="text-sm text-stone-500 mb-10">Scegli una nuova password per il tuo account.</p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.15em] font-bold text-stone-500">Nuova password</label>
            <input data-testid="reset-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full border border-stone-300 bg-white px-4 py-3 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40 transition-colors" placeholder="••••••••" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.15em] font-bold text-stone-500">Conferma password</label>
            <input data-testid="reset-confirm-input" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="mt-2 w-full border border-stone-300 bg-white px-4 py-3 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40 transition-colors" placeholder="••••••••" />
          </div>
          {error && <p data-testid="reset-error" className="text-sm text-alert">{error}</p>}
          <button data-testid="reset-submit-btn" disabled={loading}
            className="w-full rounded-full bg-brand text-white py-3.5 text-sm font-semibold hover:bg-brand-hover transition-colors disabled:opacity-60">
            {loading ? "Aggiornamento…" : "Aggiorna password"}
          </button>
        </form>
      </div>
    </div>
  );
}
